import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	explainWorkflow: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	explainWorkflow: {
		id: 'issue-field-status.status-view.explain-workflow-button.explain-workflow',
		defaultMessage: 'Explain workflow',
		description: 'Action item to explain the workflow of the work item in the status view dropdown',
	},
});

export default messages;
